import {usePotentialFilters} from '../../../features/ProductStream/utils';

export enum DiscountParamValue {
  all = 'false',
  deals = 'true',
}

export function useIsDiscountSelected() {
  const {filters} = usePotentialFilters();
  return filters.get('hasCampaignReduction');
}
